import React from 'react';
import styled from 'styled-components';
import colorLogo from '../../assets/logos/Labs_colour .png'; // GeoX LABS color version
import whiteLogo from '../../assets/logos/Labs_white.png'; // GeoX white version

const LogoWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

const LogoImage = styled.img`
  height: ${props => props.size === 'large' ? '50px' : '35px'};
  transition: all 0.3s ease;
`;

const Logo = ({ size = 'default', light = false, hideTextOnMobile = false }) => {
  // Use the white logo when light=true, color logo when light=false
  const logoSrc = light ? whiteLogo : colorLogo;
  
  return (
    <LogoWrapper>
      <LogoImage 
        src={logoSrc} 
        alt="GeoX Labs Logo" 
        size={size}
      />
    </LogoWrapper>
  );
};

export default Logo;
